import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import ArticlePreview from './components/ArticlePreview';
import FeatureGrid from './components/FeatureGrid';
import TestimonialSection from './components/TestimonialSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <ArticlePreview />
      <FeatureGrid />
      <TestimonialSection />
      <CtaSection />
      <Footer />
    </main>
  );
}